import { useQuery } from '@tanstack/react-query';
import { answerService, AnswerDto } from '../services/answer.service';

export const ANSWERS_QUERY_KEY = 'answers';

/**
 * Batch fetch multiple answers by their inspection program item IDs
 * @param organizationId Organization ID
 * @param itemIds Array of inspection program item IDs
 * @returns Map of item ID to array of AnswerDto
 */
export const useAnswersByItemIds = (organizationId: string, itemIds: string[]) => {
  return useQuery({
    queryKey: [ANSWERS_QUERY_KEY, 'batch', organizationId, itemIds],
    queryFn: async () => {
      const response = await answerService.getByItemIds(organizationId, itemIds);
      // Based on logs: responseDataKeys has 4 items at responseData level
      // So structure is: response.data = { itemId: [...], ... }
      const answersMap: Record<string, AnswerDto[]> = (response as any).data || {};
      
      console.log('Loaded answers map:', {
        itemIds: itemIds.length,
        keys: Object.keys(answersMap).length,
        success: true
      });
      
      return answersMap;
    },
    enabled: !!organizationId && itemIds.length > 0,
    staleTime: 2 * 60 * 1000, // 2 minutes cache (answers can change)
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
};

/**
 * Fetch answers for a specific inspection program item
 * @param organizationId Organization ID
 * @param inspectionId Inspection ID
 * @param programId Program ID
 * @param itemId Item ID
 * @returns Array of AnswerDto
 */
export const useAnswersByItemId = (
  organizationId: string,
  inspectionId: string,
  programId: string,
  itemId: string
) => {
  return useQuery({
    queryKey: [ANSWERS_QUERY_KEY, organizationId, inspectionId, programId, itemId],
    queryFn: async () => {
      const response = await answerService.getAnswers(organizationId, inspectionId, programId, itemId);
      return response.data;
    },
    enabled: !!organizationId && !!inspectionId && !!programId && !!itemId,
    staleTime: 2 * 60 * 1000,
  });
};
